import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api";

export const fetchProAccountAnalytics = createAsyncThunk(
    "proAccounts/fetchAnalytics",
    async (_, { rejectWithValue }) => {
      try {
        const response = await api.get("/admin/dashboard-analytics/pro-account-analytics");
        return response.data.data.dashboard;
      } catch (error: any) {
        if (error.response) {
          return rejectWithValue(error.response.data);
        }
        return rejectWithValue({ message: "An unexpected error occurred" });
      }
    }
  );
  
  export const fetchProAccountList = createAsyncThunk(
    "proAccounts/fetchAccountList",
    async (params: {page?: number; limit: number; search?: string; status?: string; subsType?: string; startDate?: string; endDate?: string  }, { rejectWithValue }) => {
      try {
        const response = await api.get("/user-management/pro-fishnity-accounts", {
          params
        });
        return response.data.data;
      } catch (error: any) {
        if (error.response) {
          return rejectWithValue(error.response.data);
        }
        return rejectWithValue({ message: "An unexpected error occurred" });
      }
    }
  );
  
  export const downloadProAccountList = createAsyncThunk(
    "proAccounts/downloadAccountList",
    async (params: { search?: string; status?: string; subsType?: string; startDate?: string; endDate?: string }, { rejectWithValue }) => {
      try {
        const response = await api.get("/admin/dashboard-analytics/subscriptions-download", {
          params,
          responseType: 'blob', // Important for file downloads
        });
        return response.data;
      } catch (error: any) {
        if (error.response && error.response.data) {
          if (error.response.data instanceof Blob) {
              try {
                  const errorText = await error.response.data.text();
                  const errorJson = JSON.parse(errorText);
                  return rejectWithValue(errorJson);
              } catch (e) {
                  return rejectWithValue({ message: "An error occurred while parsing the error response." });
              }
          }
          return rejectWithValue(error.response.data);
        }
        return rejectWithValue({ message: "An unexpected error occurred" });
      }
    }
  );
  